import PedidoCuentaRespuestaPage from "./PedidoCuentaRespuestaPage";

export {PedidoCuentaRespuestaPage}
export default PedidoCuentaRespuestaPage
